import axiosInstance from "@/services/axiosInterceptor";

export async function getBlogs() {
  try {
    const response = await axiosInstance.get(`common/blog`);
    const data = response?.data?.rows;
    return data;
  } catch (error) {
    throw error;
  }
}
